// extracted by mini-css-extract-plugin
export var character = "character-module--character--pN2lT";
export var image = "character-module--image--XoPzR";
export var name = "character-module--name--X3N7r";